import type { ArticleCard as ArticleCardType } from 'types/capi/shared';

import ArticleCard from '~/components/ArticleCard';

import { MODULE_TYPES } from './index';

type Props = {
  items: ArticleCardType[];
  modulePosition: number;
};

export default function Tiles({ items, modulePosition }: Props) {
  const [card1, card2, card3, card4, card5, card6] = items;
  if (!card1 || !card2 || !card3 || !card4 || !card5 || !card6) return null;

  const shared = {
    modulePosition,
    moduleType: MODULE_TYPES.tiles,
    name: 'LATEST_NEWS' as const,
    pagePosition: 'Homepage Article Tiles' as const
  };

  return (
    <div className="w-full bg-grey-tile">
      <div className="content-width no-scrollbar mx-auto flex gap-6 overflow-x-scroll py-10 md:py-20">
        <div className="flex flex-1 flex-col gap-6">
          <ArticleCard
            {...shared}
            item={card1}
            position={1}
            variant="4/5-text-over"
          />
          <ArticleCard
            {...shared}
            item={card2}
            options={{ oneLineTitle: true }}
            position={2}
            variant="16/9-text-under"
          />
        </div>
        <div className="flex flex-1 flex-col gap-6">
          <ArticleCard
            {...shared}
            item={card3}
            options={{ oneLineTitle: true }}
            position={3}
            variant="16/9-text-under"
          />
          <ArticleCard
            {...shared}
            item={card4}
            position={4}
            variant="4/5-text-over"
          />
        </div>
        <div className="flex flex-1 flex-col gap-6">
          <ArticleCard
            {...shared}
            item={card5}
            position={5}
            variant="4/5-text-over"
          />
          <ArticleCard
            {...shared}
            item={card6}
            options={{ oneLineTitle: true }}
            position={6}
            variant="16/9-text-under"
          />
        </div>
      </div>
    </div>
  );
}
